import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
const API_BASE =
  process.env.REACT_APP_API_BASE || 'http://localhost:10000';
export default function Verify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMessage('No verification token found.'); return; }

    fetch(`${API_BASE}/api/auth/verify/${token}`)
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (ok) { setStatus('success'); setMessage(data.message || 'Email verified!'); }
        else { setStatus('error'); setMessage(data.error || 'Verification failed.'); }
      })
      .catch(() => { setStatus('error'); setMessage('Something went wrong. Please try again.'); });
  }, [searchParams]);

  useEffect(() => {
    window.gtag?.("event", "page_view", {
      page_path: "/verify",
      page_title: "Verify",
    });
  }, []);

  return (
    <main className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-50 flex items-center justify-center px-4">
      <Card className="w-full max-w-md p-8 text-center">
        {status === 'loading' && <p className="text-slate-500">Verifying your email…</p>}

        {status === 'success' && (
          <>
            <div className="text-4xl mb-4">✓</div>
            <h1 className="text-xl font-semibold mb-2">Email verified!</h1>
            <p className="text-slate-500 mb-6">{message}</p>
            <Button onClick={() => navigate('/login')}>Log in</Button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-4xl mb-4">✗</div>
            <h1 className="text-xl font-semibold mb-2">Verification failed</h1>
            <p className="text-slate-500 mb-6">{message}</p>
            <Button variant="outline" onClick={() => navigate('/login')}>Back to login</Button>
          </>
        )}
      </Card>
    </main>
  );
}
